var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-chip",class:['tone-' + _vm.tone, { 'status-chip--small': _vm.small }]},[(_vm.icon)?_c('v-icon',{staticClass:"status-chip__icon",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.icon))]):_c('span',{staticClass:"status-chip__dot",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.status || "—")+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }